import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import PersonalizationChart from '../../../formSections/MultiSection/SummaryBox/PersonalizationChart';
import { setTeasers } from '../../../formSections/MultiSection/SummaryBox/utils';

export const TitleBox=({ props, jobSeekerData })=> {
  const styles = props.stateProps.bulletBankStyles;
  const index = props.stateProps.sectionData.sectionIndex;
  const teasers = setTeasers( props.navSections['professional-experience'], props.formikProps.values, index);
  let jobTitle = jobSeekerData[index]['job_title'];
  //JB TEMPORARY FIX FOR DEMO Need to move this to Validation.
  if(typeof jobTitle === 'undefined') {
    return null;
  } else {
    jobTitle = jobTitle.replaceAll('-', ' ');
    return (
      <Flex sx={{ ...styles.jobInfoFlex, }}>
        <Box sx={{ marginBottom: ['16px', null, 0] }}>
          <Heading variant="jobTitle">{jobTitle} </Heading>
          <Text variant="companyName">
            {jobSeekerData[index]['company_name']}
          </Text>
          <Text variant="t16">{teasers.dates}</Text>
        </Box>
        <PersonalizationChart props={props} jobSeekerDataInd={jobSeekerData[index]} />
      </Flex>
    )
  }
}
export default TitleBox;